/* eslint-disable no-shadow */
export enum ActionBehavior {
  ExternalRoute = 'EXTERNAL_ROUTE',
  Route = 'ROUTE',
  Emit = 'EMIT',
  DropDownMenu = 'DROP_DOWN_MENU',
  ExportToCSV = 'EXPORT_TO_CSV',
}
